import { Fragment, useState, useEffect } from "react";
import { TitleHeader } from "../../components/commons";
import { Button, Result, Spin } from "antd";
import * as SHARED from "../../utils/shared";
import * as ReportApi from "../../api/report";

function Reportes(props) {
  const [total, setTotal] = useState({
    participante: 0,
    docente: 0,
    estudiante: 0,
    administrativo: 0
  });
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [error, setError] = useState(null);

  const fetchDataToTable = async () => {
    try {
      setIsLoading(true);
      const res = await ReportApi.getTotales();
      setTotal(res.payload);
    } catch (error) {
      setError(error);
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchDataToTable();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoading) {
    return <Spin tip="Cargando" className="w-full py-60" />;
  }

  if (isError) {
    return (
      <Result
        status="500"
        title="Algo salió mal"
        subTitle={error.message}
        extra={
          <Button onClick={() => window.location.reload()} type="primary">
            Recargar
          </Button>
        }
      />
    );
  }

  return (
    <Fragment>
      <TitleHeader
        title="Inicio"
        extra={<span className="text-lg font-bold mt-2">{SHARED.PROCESO}</span>}
      />

      <div className="grid gap-6 mb-8 md:grid-cols-2 xl:grid-cols-4">
        <div className="min-w-0 rounded-lg border-4 border-gray-200 shadow-xs bg-white dark:bg-gray-800">
          <div className="p-4 flex items-center">
            <div className="p-3 rounded-full text-yellow-500 dark:text-yellow-100 bg-yellow-100 dark:bg-yellow-500 mr-4">
              <svg fill="currentColor" viewBox="0 0 20 20" className="w-5 h-5">
                <path d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-3a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v3h-3zM4.75 12.094A5.973 5.973 0 004 15v3H1v-3a3 3 0 013.75-2.906z"></path>
              </svg>
            </div>
            <div>
              <p className="mb-2 text-sm font-medium text-gray-600 dark:text-gray-400">
                Total participantes
              </p>
              <p className="text-lg font-semibold text-gray-700 dark:text-gray-200">
                {total.participante}
              </p>
            </div>
          </div>
        </div>
        <div className="min-w-0 rounded-lg border-4 border-gray-200 shadow-xs overflow-hidden bg-white dark:bg-gray-800">
          <div className="p-4 flex items-center">
            <div className="p-3 rounded-full text-green-500 dark:text-green-100 bg-green-100 dark:bg-green-500 mr-4">
              <svg fill="currentColor" viewBox="0 0 20 20" className="w-5 h-5">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M11.6568 14.999H7.9067C7.74021 14.999 7.59431 15.0619 7.46931 15.1867C7.3442 15.3118 7.28175 15.4575 7.28175 15.6242V19.3744C7.28175 19.5411 7.34442 19.687 7.46931 19.8119C7.59431 19.9367 7.74005 19.9994 7.9067 19.9994H11.6568C11.8233 19.9994 11.9696 19.9368 12.0941 19.8119C12.2194 19.687 12.2819 19.5411 12.2819 19.3744V15.6242C12.2819 15.4575 12.2196 15.3118 12.0941 15.1867C11.9696 15.0616 11.8233 14.999 11.6568 14.999Z"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M16.5791 3.77357C16.1519 2.98668 15.5999 2.32294 14.9227 1.78113C14.2459 1.23954 13.4849 0.807023 12.6413 0.484236C11.7976 0.161558 10.9591 0 10.1256 0C6.95907 0 4.54244 1.38545 2.87564 4.15639C2.7924 4.29173 2.76366 4.43753 2.78966 4.59383C2.81582 4.74992 2.89654 4.88017 3.03194 4.98432L5.59453 6.93763C5.72993 7.02081 5.86018 7.06246 5.98524 7.06246C6.17279 7.06246 6.33413 6.979 6.46969 6.81235C7.21958 5.87497 7.77698 5.27602 8.14153 5.01546C8.58953 4.71347 9.15187 4.56253 9.82896 4.56253C10.4644 4.56253 11.0241 4.72923 11.5087 5.06231C11.993 5.39571 12.235 5.78116 12.235 6.21866C12.235 6.70804 12.105 7.10406 11.8445 7.40616C11.5842 7.70815 11.1465 7.99968 10.5318 8.28104C9.71951 8.64559 8.97438 9.21076 8.29761 9.97641C7.62035 10.7421 7.28197 11.5572 7.28197 12.4218V13.1249C7.28197 13.323 7.33637 13.5182 7.44593 13.7109C7.55539 13.9038 7.68811 14 7.84446 14H11.5945C11.7612 14 11.9069 13.9195 12.032 13.7575C12.1567 13.5965 12.2195 13.4271 12.2195 13.2503C12.2195 12.99 12.3627 12.6406 12.6489 12.2034C12.9354 11.7659 13.2921 11.427 13.7195 11.1873C14.1256 10.9582 14.443 10.7736 14.6724 10.6328C14.902 10.4923 15.2013 10.2653 15.5712 9.95299C15.941 9.64038 16.2275 9.33045 16.4303 9.02327C16.6335 8.71602 16.8159 8.31749 16.9774 7.82778C17.1392 7.33824 17.2197 6.81213 17.2197 6.24969C17.2196 5.3851 17.0059 4.55963 16.5791 3.77357Z"
                />
              </svg>
            </div>
            <div>
              <p className="mb-2 text-sm font-medium text-gray-600 dark:text-gray-400">
                Administrativos
              </p>
              <p className="text-lg font-semibold text-gray-700 dark:text-gray-200">
                {total.administrativo}
              </p>
            </div>
          </div>
        </div>
        <div className="min-w-0 rounded-lg border-4 border-gray-200 shadow-xs overflow-hidden bg-white dark:bg-gray-800">
          <div className="p-4 flex items-center">
            <div className="p-3 rounded-full text-blue-500 dark:text-blue-100 bg-blue-100 dark:bg-blue-500 mr-4">
              <svg viewBox="0 0 20 20" fill="currentColor" className="w-5 h-5">
                <g clipPath="url(#clip0)">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.61719 12.9691H7.03125V12.3711C7.76137 11.8206 8.20312 10.9555 8.20312 10.0394V8.99283C8.20312 7.50053 7.15312 6.20447 5.76094 5.97732C4.90207 5.84057 4.0323 6.07744 3.37598 6.63537C2.72027 7.19326 2.34375 8.00693 2.34375 8.86752V10.0394C2.34375 10.9555 2.78551 11.8207 3.51562 12.3711V12.9691H2.92969C1.31434 12.9691 0 14.2834 0 15.8988V19.4144C0 19.7383 0.26207 20.0003 0.585938 20.0003H9.96094C10.2848 20.0003 10.5469 19.7383 10.5469 19.4144V15.8988C10.5469 14.2834 9.23254 12.9691 7.61719 12.9691Z"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.7266 0C11.8186 0 9.45312 2.36551 9.45312 5.27344C9.45312 6.36977 9.79586 7.4375 10.4259 8.325L9.55152 9.63594C9.43191 9.81562 9.42051 10.0468 9.52234 10.2373C9.62418 10.4279 9.82277 10.5469 10.0391 10.5469H14.7266C17.6345 10.5469 20 8.18137 20 5.27344C20 2.36551 17.6345 0 14.7266 0ZM14.7266 8.78906C14.403 8.78906 14.1406 8.52672 14.1406 8.20312C14.1406 7.87953 14.403 7.61719 14.7266 7.61719C15.0502 7.61719 15.3125 7.87953 15.3125 8.20312C15.3125 8.52672 15.0502 8.78906 14.7266 8.78906ZM15.5443 5.65797C15.4058 5.73121 15.3125 5.91891 15.3125 6.12547V6.44531C15.3125 6.76918 15.0504 7.03125 14.7266 7.03125C14.4027 7.03125 14.1406 6.76918 14.1406 6.44531V6.12547C14.1406 5.47543 14.4696 4.89922 14.9984 4.62113C15.1923 4.51926 15.3125 4.32016 15.3125 4.10156C15.3125 3.77828 15.0498 3.51562 14.7266 3.51562C14.4033 3.51562 14.1406 3.77828 14.1406 4.10156C14.1406 4.42543 13.8786 4.6875 13.5547 4.6875C13.2308 4.6875 12.9688 4.42543 12.9688 4.10156C12.9688 3.13227 13.7573 2.34375 14.7266 2.34375C15.6959 2.34375 16.4844 3.13227 16.4844 4.10156C16.4844 4.75672 16.1239 5.35297 15.5443 5.65797Z"
                  />
                </g>
                <defs>
                  <clipPath id="clip0">
                    <rect width="20" height="20" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <div>
              <p className="mb-2 text-sm font-medium text-gray-600 dark:text-gray-400">Docentes</p>
              <p className="text-lg font-semibold text-gray-700 dark:text-gray-200">
                {total.docente}
              </p>
            </div>
          </div>
        </div>
        <div className="min-w-0 rounded-lg border-4 border-gray-200 shadow-xs overflow-hidden bg-white dark:bg-gray-800">
          <div className="p-4 flex items-center">
            <div className="p-3 rounded-full text-green-400 dark:text-green-100 bg-green-100 dark:bg-green-500 mr-4">
              <svg viewBox="0 0 20 20" fill="currentColor" className="w-5 h-5">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M14.7279 0.650418C14.1671 0.3651 13.4811 0.58866 13.1958 1.14972L4.72135 17.8177C4.43611 18.3787 4.65967 19.0646 5.22066 19.3499C5.38611 19.4339 5.56242 19.4738 5.73615 19.4738C6.15136 19.4738 6.55161 19.2461 6.75277 18.8505L15.2272 2.18252C15.5125 1.62153 15.2889 0.93566 14.7279 0.650418Z"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M8.64295 6.13991C8.64295 3.75702 6.70429 1.81836 4.3214 1.81836C1.93866 1.81836 0 3.75702 0 6.13991C0 8.52273 1.93866 10.4614 4.32148 10.4614C6.70437 10.4614 8.64295 8.52273 8.64295 6.13991ZM4.32148 8.18249C3.19524 8.18249 2.2789 7.26614 2.2789 6.13991C2.2789 5.0136 3.19524 4.09726 4.32148 4.09726C5.44778 4.09726 6.36413 5.01353 6.36413 6.13991C6.36405 7.26614 5.44778 8.18249 4.32148 8.18249Z"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M15.6785 9.54004C13.2957 9.54004 11.357 11.4787 11.357 13.8615C11.357 16.2443 13.2956 18.183 15.6785 18.183C18.0614 18.183 20 16.2444 20 13.8615C20 11.4786 18.0614 9.54004 15.6785 9.54004ZM15.6785 15.904C14.5522 15.904 13.6359 14.9877 13.6359 13.8614C13.6359 12.7352 14.5522 11.8189 15.6785 11.8189C16.8048 11.8189 17.7211 12.7352 17.7211 13.8614C17.7211 14.9877 16.8049 15.904 15.6785 15.904Z"
                />
              </svg>
            </div>
            <div>
              <p className="mb-2 text-sm font-medium text-gray-600 dark:text-gray-400">
                Estudiantes
              </p>
              <p className="text-lg font-semibold text-gray-700 dark:text-gray-200">
                {total.estudiante}
              </p>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default Reportes;
